jQuery( function($) {

    var annuaireSingleIcon = L.icon({
        iconUrl: '/wp-content/themes/kreenoot-child/assets/externals/map-marker-alt-solid.png',
        iconSize: [28, 42],
        iconAnchor: [16, 46],
        popupAnchor: [0, -50],
    });

    var singleMarker = document.querySelector('.markerSingleItem');

    let latitude = parseFloat(singleMarker.querySelector('.latitude').textContent);
    let longitude = parseFloat(singleMarker.querySelector('.longitude').textContent);

    var annuaireSingleMap = L.map('planAccess').setView([latitude, longitude], 16);

    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 18,
        minZoom: 12,
        id: 'mapbox/streets-v11'
    }).addTo(annuaireSingleMap);

    let titleSingle = singleMarker.querySelector('.title').textContent;
    let addressSingle = singleMarker.querySelector('.address').textContent;

    let contentSingle = '<div class="markerPopup">';
    contentSingle += '<p>' + titleSingle + '</p>';
    contentSingle += '<p><svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" /></svg>' + addressSingle + '</p>'
    contentSingle += '</div>';

    L.marker([latitude, longitude], {icon: annuaireSingleIcon}).addTo(annuaireSingleMap).bindPopup(contentSingle).openPopup();

});